import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { OrchestrationIdentityLine } from '@app/pages/admin/orchestration-identity.util';
import { CopyableIdentifierComponent } from '@app/pages/admin/components/copyable-identifier/copyable-identifier';

@Component({
  selector: 'app-orchestration-identity-cell',
  standalone: true,
  imports: [RouterModule, TranslateModule, CopyableIdentifierComponent],
  templateUrl: './orchestration-identity-cell.html',
  styleUrl: './orchestration-identity-cell.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class OrchestrationIdentityCellComponent {
  readonly name = input.required<string>();
  readonly nameUrl = input<string | readonly string[] | null>(null);
  readonly lines = input<readonly OrchestrationIdentityLine[]>([]);
}
